import { Component, Input, computed, inject, input } from '@angular/core';
import { AbstractControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatError } from '@angular/material/form-field';
import { Country } from 'src/app/services/countries/countries.service';
import { PayeeButtonComponent } from '../../../shared/payee-buttons/payee-button/payee-button.component';
import { PayeeIconButtonComponent } from '../../../shared/payee-buttons/payee-icon-button/payee-icon-button.component';
import { PayeeAutocompleteComponent } from '../../../shared/payee-form-fields/payee-autocomplete/payee-autocomplete.component';
import { PayeeFormFieldComponent } from '../../../shared/payee-form-fields/payee-form-field/payee-form-field.component';
import { PayeeIconComponent } from '../../../shared/payee-icon/payee-icon.component';
import { PayeeInputDirective } from '../../../shared/payee-input/payee-input.directive';
import { AddressControls, EditCaseDialogService } from '../edit-case-dialog.service';

@Component({
  selector: 'app-address-form',
  templateUrl: './address-form.component.html',
  styleUrls: ['./address-form.component.scss'],
  imports: [
    PayeeIconButtonComponent,
    PayeeIconComponent,
    PayeeButtonComponent,
    PayeeFormFieldComponent,
    PayeeAutocompleteComponent,
    FormsModule,
    ReactiveFormsModule,
    PayeeInputDirective,
    MatError,
  ],
})
export class AddressFormComponent {
  private editCaseDialogService = inject(EditCaseDialogService);

  @Input({ required: true }) form!: FormGroup<AddressControls>;
  readonly countries = input<Country[]>([]);
  @Input() showToggle = true;
  readonly countryOptions = computed<number[]>(() => this.countries().map(c => c.id));

  get country_id() {
    return this.form.controls.country_id;
  }
  get settlement() {
    return this.form.controls.settlement;
  }
  get postcode() {
    return this.form.controls.postcode;
  }
  get street() {
    return this.form.controls.street;
  }

  isAiFilled(control: AbstractControl | null | undefined): boolean {
    return this.editCaseDialogService.isAiFilled(control);
  }

  readonly countryDisplayWith = (id?: number): string => {
    if (!id) {
      return '';
    }

    return this.countries().find((c) => c.id === +id)?.name ?? '';
  };

  isStreetLong(): boolean {
    const value = this.street.value as null | string;
    if (!value) {
      return false;
    }
    return value.length > 40;
  }
}
